var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppBar',{attrs:{"drawer":_vm.drawer},on:{"setDrawer":function($event){_vm.drawer = $event}}}),_c('LeftBar',{attrs:{"drawer":_vm.drawer},on:{"setDrawerResponsiveness":function($event){_vm.drawer = $event}}}),_c('v-container',{staticClass:"pa-8"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }